/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Represents a ProgramLabel entity within an Organization. Includes its persistent ID and name.
 * @export
 * @interface ProgramLabel
 */
export interface ProgramLabel {
    /**
     * Unique identifier of the ProgramLabel.
     * @type {string}
     * @memberof ProgramLabel
     */
    readonly id: string;
    /**
     * Name of the ProgramLabel. Unique per organization (case-insensitive match).
     * @type {string}
     * @memberof ProgramLabel
     */
    name: string;
}

/**
 * Check if a given object implements the ProgramLabel interface.
 */
export function instanceOfProgramLabel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ProgramLabelFromJSON(json: any): ProgramLabel {
    return ProgramLabelFromJSONTyped(json, false);
}

export function ProgramLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ProgramLabelToJSON(value?: ProgramLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

